import type { DiscountType } from '../enums/DiscountType'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { UserGroupEntity } from '@/features/userGroup/domain/entities/UserGroupEntity'
import type { DiscountCategoryEntity } from './DiscountCategoryEntity'
import type { DiscountSpecifiedItemCategoryEntity } from './DiscountSpecifiedItemCategoryEntity'

export class DiscountOfferEntity {
  id?: string
  name?: string | null
  type?: DiscountType 
  value?: number
  maxDiscountAllowed?: number
  minCartAmount?: number | null;
  start?: string
  end?: string
  firstPurchase?: boolean | null
  serviceRatio?: number
  branchRatio?: number
  priority?: number | null
  categories?: Array<DiscountCategoryEntity> | null
  specifiedItemsCategories?: Array<DiscountSpecifiedItemCategoryEntity> | null
  items?: Array<ItemMiniEntity> | null
  users?: Array<UserMiniEntity> | null
  groups?: Array<UserGroupEntity> | null
  createdAt?: string
  branch?: BranchMiniEntity;
  isActive?: boolean;
}
 